import React, { createContext, useContext, useState } from 'react';

const BreadCrumbContext = createContext();

export const BreadCrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState({
    collection: { id: null, name: null, route: null },
    asset: { id: null, name: null, route: null },
    bank_account: { id: null, name: null, route: null },
  });

  const updateBreadcrumbs = (updates) => {
    setBreadcrumbs((prev) => ({
      ...prev,
      ...updates.reduce((acc, { type, data }) => {
        acc[type] = data;
        return acc;
      }, {}),
    }));
  };

  return (
    <BreadCrumbContext.Provider value={{ breadcrumbs, updateBreadcrumbs }}>
      {children}
    </BreadCrumbContext.Provider>
  );
};

export const useBreadCrumb = () => useContext(BreadCrumbContext);
